import { render, staticRenderFns } from "./JoinTeam.vue?vue&type=template&id=2e8c7fc3&lang=html&"
import script from "./JoinTeam.vue?vue&type=script&lang=js&"
export * from "./JoinTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports